export const AUTH_METHOD_OPTIONS = [{ value: "IAM", label: "IAM" }];

export const AI_FRAMEWORKS = [
  { value: "OLLAMA", label: "Ollama" },
  { value: "OPENAI", label: "OpenAI" },
  { value: "TGI", label: "TGI" },
  { value: "SAGEMAKER", label: "Sagemaker" },
  { value: "AZURE_OPENAI", label: "Azure OpenAI" },
  { value: "BEDROCK", label: "Bedrock" },
  { value: "LITELLM", label: "LiteLLM" },
];

export const AI_MODAL_PROPERTIES = {
  OLLAMA: ["settings.endpoint", "settings.model"],
  OPENAI: ["settings.endpoint", "settings.model", "settings.apiKey"],
  TGI: ["settings.endpoint"],
  SAGEMAKER: ["settings.endpoint"],
  AZURE_OPENAI: ["settings.endpoint", "settings.model", "settings.apiKey"],
  BEDROCK: [
    "settings.model",
    "settings.authenticationMethod",
    "settings.bearerToken",
  ],
  LITELLM: ["settings.endpoint", "settings.model", "settings.bearerToken"],
};
